if (!customElements.get('content-slider')) {
    customElements.define('content-slider', class ContentSlider extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                slideHolder: this.querySelector('.content-slider__item--content'),
                slides: this.querySelectorAll('.content-slider__item__inner'),
                images: this.querySelectorAll('.content-slider__item--media img'),
                prevButton: this.querySelector('.slider-button--prev'),
                nextButton: this.querySelector('.slider-button--next'),
                slidesLength: 0,
                slideIndex: 0,
            };

            this.elements.slidesLength = this.elements.slides.length;

            if (this.elements.slideHolder && this.elements.slides.length > 0) {
                this.buildSlider();
                this.elements.prevButton.addEventListener('click', this.prevButtonClick.bind(this));
                this.elements.nextButton.addEventListener('click', this.nextButtonClick.bind(this));
                window.addEventListener('resize', this.buildSlider.bind(this));
            }
        }

        buildSlider() {
            let maxHeight = 0;

            for (let i = 0; i < this.elements.slidesLength; i++) {
                if (this.elements.slides[i].offsetHeight > maxHeight) {
                    maxHeight = this.elements.slides[i].offsetHeight;
                }
            }

            this.elements.slideHolder.style.height = maxHeight + 'px';
            this.updateSlide();
        }

        updateSlide() {
            for (let i = 0; i < this.elements.slidesLength; i++) {
                this.elements.slides[i].classList.remove('show');
                this.elements.images[i].classList.remove('show');
            }

            window.setTimeout(() => {
                this.elements.slides[this.elements.slideIndex].classList.add('show');
                this.elements.images[this.elements.slideIndex].classList.add('show');
            }, 250);
        }

        prevButtonClick() {
            this.elements.slideIndex--;

            if (this.elements.slideIndex < 0) {
                this.elements.slideIndex = (this.elements.slidesLength - 1);
            }

            this.updateSlide();
        }

        nextButtonClick() {
            this.elements.slideIndex++;

            if (this.elements.slideIndex > (this.elements.slidesLength - 1)) {
                this.elements.slideIndex = 0;
            }

            this.updateSlide();
        }
    });
}
